var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-1"},[_c('div',{staticClass:"title-banner"},[_c('img',{staticClass:"title-banner-img",attrs:{"src":require("../../../assets/images/csr_banner_01.jpg"),"alt":"csr_banner_01"}}),_c('img',{staticClass:"title-banner-img-mobile",attrs:{"src":require("../../../assets/images/csr_banner_01.jpg"),"alt":"csr_banner_mobile"}})])])
}]

export { render, staticRenderFns }